import React from "react";
import "./LoadingSpinnerBox.css";

import spinner from "../assets/vf_spinner_red_small_75.json";
import Lottie from "react-lottie-player";

function LoadingSpinner(params) {
  return (
    <div className="loading-spinner">
      <Lottie
        loop
        animationData={spinner}
        play
        style={{
          width: 80,
          height: 80,
          marginLeft: "calc(50% - 40px)",
        }}
      />
    </div>
  );
}

export default React.memo(LoadingSpinner);
